<template>
  <div id="app">
    <the-preloader v-if="preload" />
    <router-view/>
  </div>
</template>

<script>
import { computed, onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import router from '@/router'

import ThePreloader from './components/blocks/ThePreloader.vue'

export default {
  name: 'app',
  components: {
    ThePreloader
  },
  setup () {
    const store = useStore()
    const preload = computed(() => store.getters.getBigPreloader)

    const routerLocation = computed(() => router.options.history.location)

    onBeforeMount(() => {
      if (routerLocation.value !== '/auth' && routerLocation.value !== '/') {
        store.dispatch('setAuthenticatedData')
      }
    })

    return {
      preload
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Inter, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
}

.ck-source-editing-area textarea {
  left: 0;
}
</style>
